"use client";
import { Input } from "../../Input/Input.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Combobox/ComboboxClearButton/ComboboxClearButton.tsx
function ComboboxClearButton({ onMouseDown, onClick, onClear, ...others }) {
	return /* @__PURE__ */ jsx(Input.ClearButton, {
		tabIndex: -1,
		"aria-hidden": true,
		...others,
		onMouseDown: (event) => {
			event.preventDefault();
			onMouseDown?.(event);
		},
		onClick: (event) => {
			onClear();
			onClick?.(event);
		}
	});
}
ComboboxClearButton.displayName = "@mantine/core/ComboboxClearButton";
//#endregion
export { ComboboxClearButton };

//# sourceMappingURL=ComboboxClearButton.mjs.map